// Module-level holder for the admin Supabase access token so api.ts can
// inject it into Authorization headers without depending on React context.
// AdminAuthProvider keeps this in sync with the Supabase session.

let currentAccessToken: string | null = null;

export function setAdminAccessToken(token: string | null): void {
  currentAccessToken = token;
}

export function getAdminAccessToken(): string | null {
  return currentAccessToken;
}
